import { SEO_DATA } from "../constants-seo";
import { buildPageGraph, PageGraphOptions } from "./graph";

export function buildSeoPageGraph(
  pathname: string,
  seoKey: keyof typeof SEO_DATA,
  options: Omit<PageGraphOptions, "pathname" | "pageName" | "pageDescription"> = {}
) {
  const seo = SEO_DATA[seoKey];
  return buildPageGraph({
    pathname,
    pageName: seo.title,
    pageDescription: seo.description,
    description: seo.ogDescription,
    ...options,
  });
}
